import { Round } from '@/redux/reducers/gameReducer'
import { FixTypeLater } from 'react-redux'

export const TYPE_REWARD_FIELD: { [key: string]: string[] } = {
  bet_two_top: ['reward_top_two'],
  bet_two_under: ['reward_bottom_two'],
  bet_two_tod: ['reward_top_two_flip'],
  bet_three_top: ['reward_top_three'],
  bet_three_under: ['reward_bottom_three'],
  bet_three_tod: ['reward_top_three_flip'],
  bet_three_front: ['reward_bottom_three_front'],
  bet_run_top: ['reward_run_top'],
  bet_run_bottom: ['reward_run_bottom'],
  bet_four: ['reward_four'],
  bet_six: ['reward_six'],
}

type LottoConfig = {
  type: string
  reward: number
}
export type LottoConfigObject = { [type: string]: number }
export type pResponsseConfig = {
  betTwo: LottoConfig[]
  betThree: LottoConfig[]
  betOne: LottoConfig[]
  betSix: LottoConfig[]
  betFour: LottoConfig[]
}
export type responseLottoConfig = {
  betTwo: LottoConfigObject
  betThree: LottoConfigObject
  betOne: LottoConfigObject
  betSix: LottoConfigObject
  betFour: LottoConfigObject
}
export type LottoNameAndCountry = {
  name: string
  country: string
}

export enum GameType {
  YEEKEE = 'yeekee',
  YEEKEE_MALTA = 'encrypt_game',
  STOCK_LOTTO = 'stock',
  SET_FOUR_LOTTO = 'group',
  SET_SIX_LOTTO = 'group_six',
  GOVERNMENT_LOTTO = 'default',
}

export enum GameFlag {
  YEEKEE = 'yeekee',
  YEEKEE_VIP = 'yeekeeVIP',
  YEEKEE_MALTA = 'yeekee_malta',
  THAISTOCK_MORNING = 'thaistock_morning',
  THAISTOCK_AFTERNOON = 'thaistock_afternoon',
  THAISTOCK_PM = 'thaistock_pm',
  THAISTOCK_EVENING = 'thaistock_evening',
  THAI_EVENING_STOCK = 'thai_evening_stock',
  CRYPTO = 'crypto',
  VIETNAM = 'vietnam',
  LAOSTAR = 'laostar',
  HANOI = 'hanoi',
  HANOI_VIP = 'hanoi_vip',
  HANOI_SPECIAL = 'hanoi_special',
  BAAC = 'baac',
  AOMSIN = 'aomsin',
  KOREA = 'korea',
  JAPAN = 'japan',
  NIKEI = 'nikei',
  NIKEI_AFTERNOON = 'nikei_afternoon',
  HANGSENG_AFTERNOON = 'hangseng_afternoon',
  HANGSENG_MORNING = 'hangseng_morning',
  HANGSENG = 'hangseng',
  CHINA_AFTERNOON = 'china_afternoon',
  CHINA_MORNING = 'china_morning',
  TAIWAN = 'taiwan',
  SINGAPORE = 'singapore',
  EGYPT = 'egypt',
  GERMAN = 'german',
  ENGLAND = 'england',
  RUSSIA = 'russia',
  LAO = 'lao',
  INDIA = 'india',
  DOWNJONES = 'downjones',
  USA_STOCK = 'usa',
  MALAYSIA = 'malaysia',
  MALAYSIA_STOCK = 'malaysia_stock',
  LAO_STAR = 'lao_star',
  CORPORATE = 'corporate',
  GOVERNMENT = 'government',
  GOVERNMENT_SET = 'government_set',
  THAI_GOVERNMENT_SET = 'thai_government_set',
  GOVERNMENT_BANK = 'government_bank',
  GOVERNMENT_BANK_SET = 'government_bank_set',
  GSB = 'gsb',
  LAOS_GROUP_SET = 'laos_group_set',
  NIKEI_MORNING = 'nikei_morning',
}

// Simplified flag-to-visual mapping
const FLAG_MAPPINGS: Record<string, LottoNameAndCountry> = {
  // Yeekee flags
  yeekee_vip: { name: 'yeekee-vip', country: 'thailand' },
  yeekeeVIP: { name: 'yeekee-vip', country: 'thailand' },
  yeekee: { name: 'yeekee', country: 'thailand' },
  yeekee_malta: { name: 'yeekee-malta', country: 'malta' },

  // Thai stock flags
  thaistock_morning: { name: 'thai-morning-stock', country: 'thailand' },
  thaistock_afternoon: { name: 'thai-afternoon-stock', country: 'thailand' },
  thaistock_evening: { name: 'thai-stock-evening', country: 'thailand' },
  thaistock_pm: { name: 'thai-stock-pm', country: 'thailand' },
  thai_evening_stock: { name: 'thai-stock-evening', country: 'thailand' },

  // Other stock flags
  crypto: { name: 'crypto', country: 'thailand' },
  vietnam: { name: 'vietnam-lotto', country: 'vietnam' },
  laostar: { name: 'laostar', country: 'laos' },
  lao_star: { name: 'lao-star-stock', country: 'laos' },
  lao: { name: 'laos-lotto', country: 'laos' },
  laos_group_set: { name: 'laos-group-set-banner-flag', country: 'laos' },
  hanoi: { name: 'hanoi', country: 'vietnam' },
  hanoi_vip: { name: 'hanoi-vip', country: 'vietnam' },
  hanoi_special: { name: 'hanoi-special', country: 'vietnam' },
  baac: { name: 'baac-lotto', country: 'thailand' },
  aomsin: { name: 'aomsin-lotto', country: 'thailand' },
  korea: { name: 'korea-stock', country: 'korea' },
  japan: { name: 'japan-lotto', country: 'japan' },

  // International stock flags
  nikei_afternoon: { name: 'nikkei-afternoon-stock', country: 'japan' },
  nikei_morning: { name: 'nikkei-morning-stock', country: 'japan' },
  hangseng: { name: 'hangseng', country: 'hangseng' },
  hangseng_afternoon: { name: 'hangseng-afternoon-stock', country: 'hangseng' },
  hangseng_morning: { name: 'hangseng-morning-stock', country: 'hangseng' },
  china_afternoon: { name: 'china-afternoon-stock', country: 'china' },
  china_morning: { name: 'china-morning-stock', country: 'china' },
  taiwan: { name: 'taiwan-stock', country: 'taiwan' },
  singapore: { name: 'singapore-stock', country: 'singapore' },
  egypt: { name: 'egypt-stock', country: 'egypt' },
  german: { name: 'german-stock', country: 'germany' },
  england: { name: 'england-stock', country: 'england' },
  russia: { name: 'russia-stock', country: 'russia' },
  india: { name: 'india-lotto', country: 'india' },
  downjones: { name: 'dowjones-stock', country: 'usa' },
  usa: { name: 'usa-stock', country: 'usa' },
  malaysia: { name: 'malaysia-lotto', country: 'malaysia' },
  malaysia_stock: { name: 'malaysia-stock', country: 'malaysia' },

  // Government flags
  government: { name: 'thai-government-lotto', country: 'thailand' },
  government_set: { name: 'government-set-lottery', country: 'thailand' },
  thai_government_set: {
    name: 'thai-government-lotto-set',
    country: 'thailand',
  },
  government_bank: { name: 'thai-government-bank-lotto', country: 'thailand' },
  government_bank_set: {
    name: 'thai-government-bank-lotto-set',
    country: 'thailand',
  },
  gsb: { name: 'government-savings-bank', country: 'thailand' },
  corporate: { name: 'stock', country: 'thailand' },
}

export const getLottoNameAndCountryFromLottoGame = (
  type: string,
  flag?: string,
): LottoNameAndCountry => {
  // Direct flag-based mapping (simplified approach)
  if (flag && FLAG_MAPPINGS[flag]) {
    return FLAG_MAPPINGS[flag]
  }

  // Default fallback
  return { name: 'stock', country: 'thailand' }
}

export const getRoundLottoConfig: (round?: Round) => responseLottoConfig = (
  round,
) => {
  const response: pResponsseConfig = {
    betTwo: [],
    betThree: [],
    betOne: [],
    betSix: [],
    betFour: [],
  }
  const responseV2: responseLottoConfig = {
    betTwo: {},
    betThree: {},
    betOne: {},
    betSix: {},
    betFour: {},
  }
  const typeToRewardField: { [key: string]: string[] } = {
    ...TYPE_REWARD_FIELD,
  }
  if (round) {
    for (const key in typeToRewardField) {
      if (Object.prototype.hasOwnProperty.call(typeToRewardField, key)) {
        const rewardFields = typeToRewardField[key]
        let rewardValue = 0
        // Use a type assertion here
        if (
          rewardFields.every(
            (field) =>
              (round as Round & Record<string, unknown>)[field] !== undefined,
          )
        ) {
          // Calculate rewardValue based on each property
          rewardValue = rewardFields.reduce((acc, field) => {
            if (
              acc !== undefined &&
              (round as Round & Record<string, unknown>)[field] !== undefined &&
              !acc
            ) {
              return (
                ((round as Round & Record<string, unknown>)[field] as number) +
                acc
              )
            }
            return acc // Set to undefined if any property is undefined
          }, 0) as number
        }
        switch (key) {
          case 'bet_two_top':
          case 'bet_two_under':
          case 'bet_two_tod':
            if (rewardValue) {
              response.betTwo.push({ type: key, reward: rewardValue || 0 })
            }
            break
          case 'bet_three_top':
          case 'bet_three_under':
          case 'bet_three_tod':
          case 'bet_three_front':
            if (rewardValue) {
              response.betThree.push({ type: key, reward: rewardValue || 0 })
            }
            break
          case 'bet_run_top':
          case 'bet_run_bottom':
            if (rewardValue) {
              response.betOne.push({ type: key, reward: rewardValue || 0 })
            }
            break
          case 'bet_four':
            if (rewardValue) {
              response.betFour.push({ type: key, reward: rewardValue || 0 })
            }
            break
          case 'bet_six':
            if (rewardValue) {
              response.betSix.push({ type: key, reward: rewardValue || 0 })
            }
            break
        }
      }
    }
  }

  const responseKeys: (keyof pResponsseConfig)[] = [
    'betTwo',
    'betThree',
    'betOne',
    'betSix',
    'betFour',
  ]
  // Now you can iterate over response using the responseKeys
  responseKeys?.forEach((key) => {
    const newObject: { [type: string]: number } = {} // Specify the type of newObject
    response?.[key]?.forEach((item) => {
      newObject[item.type] = item.reward
    })
    responseV2[key] = newObject
  })
  return responseV2
}

export const getLottoConfig = (round?: Round) => {
  const typeToRewardField: { [key: string]: string[] } = {
    ...TYPE_REWARD_FIELD,
  }
  const response = []
  if (round) {
    for (const key in typeToRewardField) {
      if (Object.prototype.hasOwnProperty.call(typeToRewardField, key)) {
        const rewardFields = typeToRewardField[key]
        let rewardValue = 0
        // Use a type assertion here
        if (
          rewardFields.every(
            (field) =>
              (round as Round & Record<string, unknown>)[field] !== undefined,
          )
        ) {
          // Calculate rewardValue based on each property
          rewardValue = rewardFields.reduce((acc, field) => {
            if (
              acc !== undefined &&
              (round as Round & Record<string, unknown>)[field] !== undefined &&
              !acc
            ) {
              return (
                ((round as Round & Record<string, unknown>)[field] as number) +
                acc
              )
            }
            return acc // Set to undefined if any property is undefined
          }, 0) as number
        }
        response.push({ type: key, reward: rewardValue || 0 })
      }
    }
  }
  return response
}

type BetRuleData = {
  bet_type: string
  bet_price: number
}
export const getRuleData = (round?: Round) => {
  const betRuleData: BetRuleData[] = []
  if (round) {
    for (const key in TYPE_REWARD_FIELD) {
      if (Object.prototype.hasOwnProperty.call(TYPE_REWARD_FIELD, key)) {
        const rewardFields = TYPE_REWARD_FIELD[key]
        let rewardValue = 0
        if (
          rewardFields.every(
            (field) => (round as FixTypeLater)[field] !== undefined,
          )
        ) {
          rewardValue = rewardFields.reduce((acc, field) => {
            if (
              acc !== undefined &&
              (round as FixTypeLater)[field] !== undefined
            ) {
              return (round as FixTypeLater)[field]
            }
            return acc
          }, 0) as number
          if (rewardValue) {
            betRuleData.push({ bet_price: rewardValue, bet_type: key })
          }
        }
      }
    }
  }
  return betRuleData
}

export const isGroupLotto = (gameType: string) => {
  return ['group', 'group_six', 'group_four'].includes(gameType)
}

export const isEncryptLotto = (gameType: string): boolean => {
  return gameType === 'encrypt_game'
}

export const isYeekeeType = (gameType: string) => {
  return [
    'yeekee',
    'yekee',
    'yeekee_vip',
    'yekee_vip',
    'yeekee_malta',
    'yeekee_malta',
  ].includes(gameType)
}
